import {Component, OnInit, Inject} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Model_Datasource, AbwDatasourceJointure } from 'src/app/app.models';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'abw-datasource-designer-jointure-modal',
    templateUrl: './datasource-designer-jointure-modal.component.html',
    styleUrls: ['./datasource-designer-jointure-modal.component.scss']
})
export class DatasourceDesignerJointureModalComponent implements OnInit {
    activeDatasource: Model_Datasource;
    activeDatasourceColumns: string[];

    datasources: Model_Datasource[] = [];
    formGroup = this._formBuilder.group({
        FK_COLUMN: [null, Validators.required],
        NUM_DATASOURCE: [null, Validators.required],
        JOIN_COLUMN: [null, Validators.required],
    });
    selectedDatasource: Model_Datasource;
    selectedDatasourceColumns: string[] = [];

    constructor(
        private _dialogRef: MatDialogRef<DatasourceDesignerJointureModalComponent>,
        private _formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: { activeDatasource: Model_Datasource; datasources: Model_Datasource[] },
    ) {
        this.activeDatasource = data.activeDatasource;
        if (!!this.activeDatasource && !!this.activeDatasource.DS_PARAMS && !!this.activeDatasource.DS_PARAMS.DS_COLUMNS) {
            this.activeDatasourceColumns = this.activeDatasource.DS_PARAMS.DS_COLUMNS.map(c => c.name);
        } else {
            this.activeDatasourceColumns = [];
        }
        this.datasources = data.datasources;
    }

    ngOnInit() { 
    }

    onClose() {
        this._dialogRef.close();
    }

    onSubmit() {
        if (this.formGroup.invalid) { return; }
        const dsJoin: AbwDatasourceJointure = this.formGroup.value;
        this._dialogRef.close(dsJoin);
    }

    onDatasourceSelected(_numDatasource: string) {
        this.selectedDatasource = this.datasources.find(d => d.NUM_DATASOURCE == _numDatasource);
        if (!!this.selectedDatasource && !!this.selectedDatasource.DS_PARAMS && !!this.selectedDatasource.DS_PARAMS.DS_COLUMNS) {
            this.selectedDatasourceColumns = this.selectedDatasource.DS_PARAMS.DS_COLUMNS.map(c => c.name);
        } else {
            this.selectedDatasourceColumns = [];
        }
    }


}